import React from "react";
import { Link } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import "./Unauthorized.css";

const Unauthorized = () => {
  const { instance } = useMsal();

  const handleLogout = () => {
    instance.logoutRedirect({ postLogoutRedirectUri: "/" });
  };

  return (
    <div
      className="unauthorized-container"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/loginbg.png)`,
      }}
    >
      {/* <div className="unauthorized-navbar">
        <div className="navbar-brand">
          <img
            src={`${process.env.PUBLIC_URL}/images/SAS_Logo.png`}
            alt="SAS"
            className="navbar-logo"
          />
          <span className="navbar-text">| SPIRIT AIR CARGO HANDLING</span>
        </div>
      </div> */}
      <div className="unauthorized-content">
        <div className="unauthorized-card">
          <div className="unauthorized-icon">🔒</div>
          <h2 className="unauthorized-title">Access Restricted</h2>
          <p className="unauthorized-message">
            You do not have the required privileges to view this page.
          </p>
          <p className="unauthorized-sub">
            Please contact your administrator to request access to this
            resource.
          </p>
          <div className="unauthorized-actions">
            <Link to="/" className="unauthorized-home-btn">
              Go to Homepage
            </Link>
            <button className="unauthorized-logout-btn" onClick={handleLogout}>
              Sign in with another account
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
